// src/hooks/useScrollRestoration.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCROLL_POS_KEY = "saved-scroll-position";

export const useScrollRestoration = () => {
  const location = useLocation();

  // 保存当前滚动位置（在页面卸载前）
  useEffect(() => {
    const scrollPos = sessionStorage.getItem(SCROLL_POS_KEY);
    if (scrollPos) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(scrollPos, 10));
        sessionStorage.removeItem(SCROLL_POS_KEY);
      }, 50); // 50ms 延迟等待 DOM 完全渲染
    }
  }, [location.pathname]);

  // 保存滚动位置（在页面加载后）
  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem(SCROLL_POS_KEY, window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
};
